function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 999.1 251.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0,125.82a3.74,3.74,0,0,1,6.35-2.68l93.16,90.78a3.74,3.74,0,0,0,5.23,0L197,123.21a3.74,3.74,0,0,1,6.36,2.66V152a3.79,3.79,0,0,1-1.12,2.67l-97.53,95.85a3.74,3.74,0,0,1-5.23,0L1.13,154.64A3.74,3.74,0,0,1,0,152Zm99.51-55.9a3.75,3.75,0,0,1,5.25,0l54.51,53.33a3.73,3.73,0,0,1,0,5.35l-54.52,53.13a3.73,3.73,0,0,1-5.23,0L45.6,128.57a3.73,3.73,0,0,1,0-5.32Zm5.21,35.46a3.73,3.73,0,0,0-5.21,0L80.92,123.27a3.74,3.74,0,0,0,0,5.34L99.46,147.2a3.74,3.74,0,0,0,5.31,0L123,128.58a3.74,3.74,0,0,0,0-5.28ZM98.65,1.05a3.75,3.75,0,0,1,5.21,0L192.6,87.54a3.74,3.74,0,0,1,0,5.34L179,106.35a3.74,3.74,0,0,1-5.24,0L103.87,38.09a3.75,3.75,0,0,0-5.22,0L28.51,106.4a3.73,3.73,0,0,1-5.2,0l-14-13.52a3.74,3.74,0,0,1,0-5.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.65,81.6h24L331.58,174H307.82l-6.34-18.35H265.84L259.51,174H235.75Zm23,54.39-11-31.81-11,31.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.65,144.44h22c1.72,8.05,7.53,13.59,17.82,13.59,9.25,0,15.19-4.09,15.19-10.69,0-4.75-3-7.79-9.9-9.11l-19.28-3.82c-15.31-3-23.89-10.56-23.89-25.88,0-16.63,14.92-28.77,36-28.77,21.51,0,35.51,11.22,36.43,29.7H390.32c-1.19-6.87-6.07-11.88-14.79-11.88-8.44,0-13.86,3.17-13.86,9.24,0,4.35,2.64,6.33,8.19,7.39l21,4c15.57,2.9,23.89,11.75,23.89,26.27,0,18.61-15.71,31.41-37.49,31.41C354.55,175.85,339.63,163.58,337.65,144.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2,81.6h70.36v19.67H450.91v16h45.93v19.66H450.91v17.43h48.71V174H428.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.79,81.6H543l23.63,62.05L590.3,81.6h28.25V174H597.3V112.89L575,174H558.35l-22.3-61.12V174H514.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.7,81.6h42.64c23.1,0,36,12.41,36,30,0,17.82-13.73,30.1-36,30.1H658.41V174H635.7Zm40.4,41.45c10.29,0,15.57-4.62,15.57-11.74,0-6.6-5.28-11.09-15.57-11.09H658.41v22.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.65,81.6H797v19.67H749.35v16h45.94v19.66H749.35v17.43h48.71V174H726.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.24,81.6H860.1c22,0,35.38,12.41,35.38,29.71,0,13.33-8.05,23.62-21.25,27.72l17.16,35H865.25l-16-32.87H836V174H813.24Zm45.54,40.93c8.71,0,14-4.49,14-11.36,0-6.33-5.28-11-14-11H836v22.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.17,81.6h24L999.1,174H975.34L969,155.66H933.36L927,174H903.26Zm23,54.39-11-31.81-11,31.81Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.1b59bbb0887dce8419b3b4c66f2f0665.svg";
export { ForwardRef as ReactComponent };